import React from "react"

class ThemeHeaderComponent extends React.Component {

	render() {
		return (
			<div className={"custom-header-cell " + (this.props.row.isSubTheme ? "sub" : "") + "theme"}>
				{this.props.row.title}
				<div className="actions">
					{this.props.row.consulted ? null :
					[
						this.props.row.isSubTheme ? null : <button key={0} onClick={this._handleAddSubThemeClick.bind(this)} title="Ajouter une sous-thématique"><i className="fa fa-plus" /></button>,
						<button key={1} onClick={this._handleCreateProjectClick.bind(this)} title="Ajouter un projet"><i className="fa fa-file" /></button>,
						<button key={2} onClick={this._handleClick.bind(this)} title="Modifier la thématique"><i className="fa fa-edit" /></button>,
						<button key={3} onClick={this._handleDeleteClick.bind(this)} title="Supprimer la thématique"><i className="fa fa-trash" /></button>
					]}
					<button onClick={this._handleToggleThemeClick.bind(this)} title={(this.props.row.isShown ? "Masquer" : "Afficher") + " la thématique"}><i className={"fa fa-chevron-" + (this.props.row.isShown ? "up" : "down")} /></button>
				</div>
			</div>
		)
	}

	_handleAddSubThemeClick() {
		this.props.onCustomAction("add_sub_investment_theme", this.props.row.item)
	}

	_handleCreateProjectClick() {
		this.props.onCustomAction("new_project", {theme: this.props.row.theme, subtheme: this.props.row.subtheme})
	}

	_handleClick() {
		this.props.onCustomAction("alter_investment_theme", this.props.row.item)
	}

	_handleDeleteClick() {
		this.props.onCustomAction("destroy_investment_theme", this.props.row.item)
	}

	_handleToggleThemeClick() {
		this.props.onCustomAction("toggle_investment_theme", this.props.row.item)
	}

}

export default ThemeHeaderComponent



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/investments/theme-header-component.js